module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_9016.46c43386.png";